import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AudioProvider from './components/context/audio';
import PlayerProvider from './components/context/player';

ReactDOM.render(
  <React.StrictMode>
    <PlayerProvider>
      <AudioProvider>
        <App />
      </AudioProvider>
    </PlayerProvider>
  </React.StrictMode>,
  document.getElementById('root')
);